export default "__VITE_ASSET__2102954a__"